export default __webpack_public_path__ + "static/media/market_insights.7a2bd4a7.svg";